var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "swiper" },
        [
          _c(
            "mt-swipe",
            { staticClass: "spacing", attrs: { auto: 4000 } },
            _vm._l(_vm.swipeList, function(img, index) {
              return _c("mt-swipe-item", { key: index }, [
                _c("div", [_c("img", { attrs: { src: img.slideshowPath } })])
              ])
            }),
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "iconList" }, [
        _c("ul", [
          _c("li", { on: { click: _vm.repair } }, [
            _c("img", {
              attrs: { src: require("../../assets/img/property/repair.png") }
            }),
            _c("p", [_vm._v("设备报修")])
          ]),
          _c("li", { on: { click: _vm.cost } }, [
            _c("img", {
              attrs: { src: require("../../assets/img/property/property.png") }
            }),
            _c("p", [_vm._v("物业费")])
          ]),
          _c("li", { on: { click: _vm.demand } }, [
            _c("img", {
              attrs: { src: require("../../assets/img/property/water.png") }
            }),
            _c("p", [_vm._v("水电费")])
          ]),
          _c("li", { on: { click: _vm.setting } }, [
            _c("img", {
              attrs: { src: require("../../assets/img/property/setting.png") }
            }),
            _c("p", [_vm._v("账号设置")])
          ])
        ])
      ]),
      _c("Announcement")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }